import * as React from 'react';

import { LoyaltyProgramEducation } from 'models/common/loyalty-education';

import { LoyaltyEducationPerksContent } from './loyalty-education-perks-content';

interface LoyaltyProgramEducationContentProps {
  content: LoyaltyProgramEducation;
}

export const LoyaltyProgramEducationContent: React.FunctionComponent<LoyaltyProgramEducationContentProps> = ({ content }) => {
  if (!content) {
    return null;
  }

  return (
    <React.Fragment>
      <LoyaltyEducationPerksContent perks={content.perks} />
      {content.joinProgramText && <p className="uitk-type-paragraph-300 all-b-margin-three">{content.joinProgramText}</p>}
    </React.Fragment>
  );
};
LoyaltyProgramEducationContent.displayName = 'LoyaltyProgramEducationContent';
